<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{$t('Technicians')}}</h1>
          <h2 class="page-subtitle"> {{ totalCount }} {{ totalCount === 1 ? $t('technician') + $t('saved') : $t('technicians') + $t('saved.s')}}</h2>
        </div>
        <b-button class="ph-btn" variant="primary" @click="clickOnCreateBtn" v-if="allowCreate">
           {{$t('Add2')}} {{$t('a')}} {{$t('technician')}}  <i class="ph-custom ph-user-plus-fill ml-1"/>
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableTechnician"
          identifier="B122TableTechnician"
          get-b122-table-results-url="/technician/getB122TableResults"
          :fields="tableFields"
          :editItem=allowEdit
          :deleteItem=allowDelete
          :empty-title="$t('technician.emptyTitle').toString()"
          :empty-text="$t('technician.emptyText').toString()"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn">

          <template #cell(actions)="row">
            <div class="actions-container text-right" v-if="!row.item.isDefaultTechnician">
              <button class="action-btn edit mr-1" @click="clickOnEditBtn(row)" v-if="allowEdit">
                <i class="ph-custom ph-pencil-simple-line-fill"/>
              </button>
              <button class="action-btn delete" @click="clickOnDeleteBtn(row)" v-if="allowDelete">
                <i class="ph-custom ph-trash-fill"/>
              </button>
            </div>
          </template>

          <template #cell(department)="row">
             <div>{{formatDepartment(row.item.department)}}</div>
          </template>

          <template #cell(structure)="row">
            <div class="textual-link" @click="goToStructure(row.item.structure.id)">{{row.item.structure.name}}</div>
          </template>

        </b122-table>
      </b-card>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="false"
      :selectedItem="selectedItem"
      controllerName="technician"
      itemSingularName="technician"
      itemSingularNameUpp="Technician"
      @didDeleteItem="didDeleteItem()">
    </Item-delete-modal>

  </div>
</template>

<script>

import B122Table from '../../components/b122/B122Table'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'
export default {

  name: 'TechnicianIndex',

  components: {
    B122Table,
    ItemDeleteModal
  },

  data () {
    return {

      totalCount: 0,
      allowCreate: this.$store.getters.isAdmin || this.$store.getters.isStructure || this.$store.getters.isSuperAdmin,
      allowDelete: this.$store.getters.isAdmin || this.$store.getters.isStructure || this.$store.getters.isSuperAdmin,
      allowEdit: this.$store.getters.isAdmin || this.$store.getters.isStructure || this.$store.getters.isSuperAdmin,
      selectedItem: null

    }
  },

  computed: {

    tableFields () {
      return [
        {
          label: '',
          key: 'show',
          sortable: false,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('technician.Lastname'),
          key: 'user.lastName',
          sortable: true,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('technician.Firstname'),
          key: 'user.firstName',
          sortable: true,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('technician.Email'),
          key: 'user.username',
          sortable: true,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('technician.Tel'),
          key: 'user.phoneNumber',
          sortable: false,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('technician.Structure'),
          key: 'structure',
          sortable: true,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('technician.department.s'),
          key: 'department',
          sortable: false,
          tdClass: 'max-width-cell'
        },
        {
          label: this.$i18n.t('technician.farmers.monitored'),
          key: 'nbFarmers',
          sortable: false,
          tdClass: 'max-width-cell'
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'max-width-cell'
        }
      ]
    }

  },

  methods: {

    formatDepartment(value){
      return value.map(item => item.num_dep).join(', ');
    },


    setTotalCount (totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn () {
      this.$router.push({
        name: 'TechnicianCreate'
      })
    },

    clickOnShowBtn (row) {
      this.$router.push({
        name: 'TechnicianShow',
        params: {
          techId: row.item.id
        }
      })
    },

    clickOnEditBtn (row) {
      this.$router.push({
        name: 'TechnicianEdit',
        params: {
          techId: row.item.id
        }
      })
    },

    clickOnDeleteBtn (row) {
      this.selectedItem = row.item
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteItem () {
      this.selectedItem = null
      this.$refs.B122TableTechnician.refreshTable()
    },

    goToStructure(id){
      this.$router.push({
        name: 'StructureShow',
        params: {
          structureId: id
        }
      })
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/technician/TechnicianIndex.vue